import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-case-details-header',
    templateUrl: './case-details-header.component.html',
    styleUrls: ['./case-details-header.component.scss'],
    standalone: false
})
export class CaseDetailsHeaderComponent {
    @Input() companyName: string = 'Company Name';
    @Input() departmentName: string = 'Department Name';
    @Input() companyLogoId?: string = null;
    @Input() departmentEmail?: string = '';
    constructor() {}
}
